"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartFarmingItems = exports.useCommonUserMenuItems = exports.useDataAndPrivacySidbarItem = void 0;
var react_intl_1 = require("react-intl");
var messages_1 = require("../../messages");
var types_1 = require("./types");
var menuMessages = messages_1.commonMessages.menu;
var useDataAndPrivacySidbarItem = function (isDataAndPrivacyEnabled) {
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var items = [
        {
            key: 'data-and-privacy',
            label: formatMessage(menuMessages.dataAndPrivacy),
            to: "".concat(types_1.EAuthRoutes.USER).concat(types_1.EAuthRoutes.DATA_AND_PRIVACY),
            testId: 'sidebar-data-and-privacy',
        },
    ];
    return isDataAndPrivacyEnabled ? items : [];
};
exports.useDataAndPrivacySidbarItem = useDataAndPrivacySidbarItem;
var useCommonUserMenuItems = function () {
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    return [
        {
            key: 'log-in-and-security',
            label: formatMessage(menuMessages.logInAndSecurity),
            to: "".concat(types_1.EAuthRoutes.USER).concat(types_1.EAuthRoutes.LOGIN_AND_SECURITY),
            testId: 'sidebar-log-in-and-security',
        },
        {
            key: 'personal-data',
            label: formatMessage(menuMessages.personalData),
            to: "".concat(types_1.EAuthRoutes.USER).concat(types_1.EAuthRoutes.PERSONAL_DATA),
            testId: 'sidebar-personal-data',
        },
    ];
};
exports.useCommonUserMenuItems = useCommonUserMenuItems;
var useSmartFarmingItems = function (externalLinks) {
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    if (!externalLinks) {
        return [];
    }
    var _a = messages_1.commonMessages.smartFarming, appNameFendt = _a.appNameFendt, appNameValtra = _a.appNameValtra, appNameMassey = _a.appNameMassey;
    var items = [
        {
            label: formatMessage(appNameFendt),
            key: 'fendt',
            to: (externalLinks === null || externalLinks === void 0 ? void 0 : externalLinks.fendt) || '',
            trailingIcon: 'launch',
            isTargetBlank: true,
        },
        {
            label: formatMessage(appNameValtra),
            key: 'valtra',
            to: (externalLinks === null || externalLinks === void 0 ? void 0 : externalLinks.valtra) || '',
            trailingIcon: 'launch',
            isTargetBlank: true,
        },
        {
            label: formatMessage(appNameMassey),
            key: 'massey-ferguson',
            to: (externalLinks === null || externalLinks === void 0 ? void 0 : externalLinks.massey) || '',
            trailingIcon: 'launch',
            isTargetBlank: true,
        },
    ].filter(function (i) { return i.to !== ''; });
    return [
        {
            label: formatMessage(menuMessages.smartFarming),
            icon: 'agco_machines-outline',
            type: 'list',
            testId: 'test-id-smart-farming',
            listData: {
                basePath: types_1.EAuthRoutes.SMART_FARMING,
                items: items,
            },
        },
    ];
};
exports.useSmartFarmingItems = useSmartFarmingItems;
